var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"w100 shiyong-box"},[_c('div',{staticClass:"lingqu-text"},[_vm._v("立即联系我们，提供演示版本")]),_c('div',{staticClass:"tel-num"},[_c('img',{staticClass:"tel-img",attrs:{"src":require("@/assets/img/tel-icon1.png"),"alt":"","srcset":""}}),_vm._v(" 029-89531063 ")])])])
}]

export { render, staticRenderFns }